import 'jquery.marquee';

export default class Marquee {
  constructor() {
    this.selector = '.mrkee';

    this.settings = {
      duration: 10000,
      direction: 'left',
      gap: 50,
      delayBeforeStart: 0,
      duplicated: true,
      pauseOnHover: false,
      startVisible: true,
    };
  }

  bootstrap() {
    this.init();
    window.addEventListener('resize', this.reinit.bind(this));
  }

  init() {
    // Style: Default
    const $mrk = $('.b-continuous-logo-carousel-style-default .mrkee');

    $mrk.each((idx, item) => {
      const $item = $(item);
      const duration = $item.data('mk-duration') || this.settings.duration;
      let gap;
      const direction = $item.data('mk-direction') || this.settings.direction;
      const desktopDown = window.matchMedia('(max-width: 991px)');

      if (desktopDown.matches) {
        gap = 0;
      } else {
        gap = $item.data('mk-gap') || this.settings.gap;
      }

      $item.marquee({
        ...this.settings,
        duration,
        gap,
        direction,
      });
    });

    // Style: Alternative
    const $mrkAlternative = $('.b-continuous-logo-carousel-style-alternative .mrkee');

    $mrkAlternative.each((idx, item) => {
      const $item = $(item);
      const duration = $item.data('mk-duration') || this.settings.duration;
      let gap;
      const direction = $item.data('mk-direction') || this.settings.direction;
      const desktopDown = window.matchMedia('(max-width: 991px)');

      if (desktopDown.matches) {
        gap = 10;
      } else {
        gap = $item.data('mk-gap') || this.settings.gap;
      }

      $item.marquee({
        ...this.settings,
        duration,
        gap,
        direction,
      });
    });
  }

  reinit() {
    $('.mrkee').marquee('destroy');
    this.init();
  }
}
